import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuditdetailsserviceService } from './auditdetailsservice.service';
import { ArtifactAccessibilityModel, AuditFrequencyModel, DevelopmentMethodologyModel, projectNamesModel } from './DataModels';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditModel, GeneralCategoryResDTO, CategoryIdsubauditorDTO } from 'src/app/Models/audit/audit.model';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { Observable, forkJoin } from 'rxjs';
import { DatePipe } from '@angular/common';
import { AuditPointOfContact } from 'src/app/Models/audit/auditPointofcontact.model';
import { AuditAccessibilityModel } from 'src/app/Models/audit/auditAccessibility.model';
import { AuditProjectArtifactModel } from 'src/app/Models/audit/auditProjectArtifact.model';
import { AuditByIdModel } from 'src/app/Models/audit/auditById.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserModel } from 'src/app/Models';
import { AuditSharedService } from 'src/app/services/Audit/audit-shared.service';
import { ToastrService } from 'ngx-toastr';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { EmployeeService } from 'src/app/views/employee-profile/employee-profile.service';
import { debounce,distinctUntilChanged,filter,switchMap } from 'rxjs/operators';
import moment from 'moment';

interface listUsers {
  userName: string;
  userId: number;
}
interface City {
  name: string,
  code: string
}
interface auditsaveform {
  projectId: number,
  statusId: number,
  managerId: number,
  // auditorId: number,
  TechStackIds: number[],
  uIpointofContactID: number,
  projectPOC: number,
  middleTierCloudPointofContact: number,
  isActive: true,
  createdBy: number,
  createdDate: string,
  modifiedBy: number,
  modifiedDate: string,
  // subAuditorId: [];
}

@Component({
  selector: 'app-auditor-details',
  templateUrl: './auditor-details.component.html',
  styleUrls: ['./auditor-details.component.css']
})
export class AuditorDetailsComponent implements OnInit {
  isBlockVisible = false;
  isBlockVisible1 = false;
  isBlockVisible2 = false;
  isBlockVisible3 = false;
  isBlockVisible4 = false;

  myOptions: any[] = [
    { label: 'Option 1', value: 'option1' },
    { label: 'Option 2', value: 'option2' },

  ];
  selectedOptions: any[] = [];
  audit: AuditModel;
  CategoryIdsubauditorModel: CategoryIdsubauditorDTO;
  projectnames: Array<projectNamesModel> = [];
  filteredProjects: Array<projectNamesModel> = [];
  filteredValue: any[] = [];
  filteredAuditors: any[] = [];
  hideSummaryFields: boolean;
  artifactAccessibilities: Array<ArtifactAccessibilityModel> = [];
  developmentMethodologies: Array<DevelopmentMethodologyModel> = [];
  filteredSubAuditorsName: Array<UserModel> = []; 
  Auditorname: any[] = [];
  subauditor: any;
  techstack: any;
  projectId: number = 0;
  TechStackIds: number[];
  userId: number = 0;
  searchValue: string = '';
  storeManagerNames: any;
  storeProjectManagerNames: any = [];
  storeDelieveryManagerNames : any = [];
  storePortfolioLeaderNames:  any = [];
  filteredProjectManagerNames: any = [];
  managerNameControl = new FormControl();
  portfolioLeaderControl = new FormControl();
  filteredPortfolioLeaderNames = this.storePortfolioLeaderNames;
  projectNameControl = new FormControl();
  deliveryManagerNameControl = new FormControl();
  AuditorNameControl = new FormControl('');
  filteredDeliveryManagerNames: any = [];
  storePointofContactsNames: any;
  projectPOCControl = new FormControl();
  filteredPointofContactsNames: Observable<any[]>;
  filteredAuditReports: Observable<any[]>;
  storeProjectPointofContact: any;
  storeCloudOrMiddleTierPointofContact: any;
  storeFunctionalOverviewPointOfContacts: any;
  storeOverAllApplicationPointOfContacts: any;
  storeOverAllArchitecturePointOfContacts: any;
  storeOverAllDesignPointOfContacts: any;
  storeTechnicalPointOfContacts: any;
  storeNonTechnicalPointOfContacts: any;
  Auditdetails !: FormGroup;
  Auditcreation !: FormGroup;

  AuditForm !: FormGroup;
  AuditDetailForm !: FormGroup;
  AuditSummaryForm !: FormGroup;
  AuditGeneralForm !: FormGroup;
  AuditPOCForm !: FormGroup;
  AuditAccessibilityForm !: FormGroup;
  AuditDocumentForm !: FormGroup;

  auditModel: AuditModel;
  auditByIdModel: AuditByIdModel;
  selectedAuditor: any;

  loginId: number;
  roleName: any;

  pointOfContact = new AuditPointOfContact();
  artifactType = new AuditAccessibilityModel();

  storeAuditId: number;
  id: number;

  formGroup!: FormGroup;
  storeTechnology: any;
  cities: City[];
  today = new Date(Date.now());
  dateControl = new FormControl(this.today, [Validators.required]);
  endDateControl = new FormControl({ value: '', disabled: true }, [Validators.required]);
  response: any;
  storeSubAuditorName: any;
  auditorName: string;
  managerName: string;
  storemanagername: any;
  storeProjectName:  any = [];
  auditId: number = 0;
  currentDateTime = new Date();
  private ApiUrl = environment.apiUrl;
  auditStartDate: string;
  auditFreqOptions:Array<AuditFrequencyModel> = [];
  auditReportControl = new FormControl();
  selectedProjectStatusId: any;
  projectDetail: any;
  auditStatus: any;

  get hasRoleName(): boolean {
    if (localStorage.getItem('role') == 'Auditor')
      return false;
    else
      return true;
  }

  get hasHideOrDisabled(): boolean {
    if (this.auditId != undefined && this.auditId > 0)
      return true;
    else
      return false;
  }

  constructor(private readonly formBuilder: FormBuilder, private auditdetailsservice: AuditdetailsserviceService, private employeeService: EmployeeService,
    private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private auditOverviewService: AuditOverviewService,
    public datepipe: DatePipe, private http: HttpClient, public toaster: ToastrService, private auditSharedService: AuditSharedService) {
    this.auditModel = new AuditModel();
    this.auditModel.generalcategoryDTO = new GeneralCategoryResDTO();
    this.auditModel.projectArtifactsDTO = new AuditProjectArtifactModel();
    this.auditModel.projectArtifactsDTO.articraftDTO = [];
    this.currentDateTime = new Date();
    this.auditId = 0;
  }

  buildAuditForm() {
  
    
    this.AuditForm = this.formBuilder.group({
      projectId: [null, [Validators.required]],
      TechStackIds: [[], [Validators.required]],
      managerId: [null, [Validators.required]],
      managerTypeId: null,
      deliveryManagerId:[null, [Validators.required]], 
      portfolioManagerId:[null, [Validators.required]],
      dateControl: this.dateControl,
      endDateControl: [{ value: this.endDateControl.value, disabled: true }, [Validators.required]]
    });

    const endDate = new Date(this.today);
    endDate.setDate(endDate.getDate() + 15);
    const formattedEndDate = `${('0' + endDate.getDate()).slice(-2)}/${('0' + (endDate.getMonth() + 1)).slice(-2)}/${endDate.getFullYear()}`;

    this.AuditForm.get('endDateControl').setValue(formattedEndDate);

    this.AuditGeneralForm = this.formBuilder.group({
      generalProjectId: null,
      projectDuration: '',
      codeReviewFrequencyAndProcess: '',
      teamSize: '',
      timeForLastAudit: '',
      earlierAuditReportReviewAndApprovedBy: [0,[Validators.min(1)]],
      scopeOfAudit: '',
      deliveryModel: '',
      developmentMethodology: [0,[Validators.min(1)]],
      comments: '',
      auditFrequency: [0,[Validators.min(1)]],
      projectDocumentationPath: '',
    });
    this.AuditPOCForm = this.formBuilder.group({
      overviewPOCId: [0,[Validators.min(1)]],
      demoPOCId: [0,[Validators.min(1)]],
      architecturePOCId: [0,[Validators.min(1)]],
      designAppPOCId: [0,[Validators.min(1)]],
      techQueryPOCId: [0,[Validators.min(1)]],
      nonTechQueryPOCId: [0,[Validators.min(1)]],

      overviewPOCTypeId: null,
      demoPOCTypeId: null,
      architecturePOCTypeId: null,
      designAppPOCTypeId: null,
      techQueryPOCTypeId: null,
      nonTechQueryPOCTypeId: null
    });

    this.AuditAccessibilityForm = this.formBuilder.group({
      applicationDatabaseId: null,
      businessRequirementDocumentsId: null,
      architectureDocumentsId: null,
      designDocumentsId: null,
      applicationCodeRepositoryId: null,
      earlierApplicationAuditDocumentsId: null,
      codeAnalysisCodeReviewReportsId: null,
      seperateAppCodeDocumentId: null,

      applicationDatabaseTypeId: null,
      businessRequirementDocumentsTypeId: null,
      architectureDocumentsTypeId: null,
      designDocumentsTypeId: null,
      applicationCodeRepositoryTypeId: null,
      earlierApplicationAuditDocumentsTypeId: null,
      codeAnalysisCodeReviewReportsTypeId: null,
      seperateAppCodeDocumentTypeId: null,
    });
    this.AuditDocumentForm = this.formBuilder.group({
      document: null
    })
  }

  ngOnInit() {
    this.todisable();
    this.hideSummaryFields = this.auditOverviewService.getHideSummaryFields();
    this.loginId = parseInt(localStorage.getItem('Id'));
    this.roleName = localStorage.getItem('role');     
    this.buildAuditForm();
    // this.getAuditorName(); //All employees
    // this.getSubAuditorName();
    this.getPointOfContactTypes();
    this.filteredPointofContactsNames = this.projectPOCControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filter(value))
    );
    this.dateControl.valueChanges.subscribe(value => {
      this.updateEndDate(value);
    });
    this.filteredProjectManagerNames = this.managerNameControl.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value.toLowerCase() : ''),
      map(value => (value.length > 2 ? this.filterManagers(value) : []))
    );
    this.filteredPortfolioLeaderNames = this.portfolioLeaderControl.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value.toLowerCase() : ''),
      map(value => (value.length > 2 ? this.filterLeaders(value) : []))
    );
    // this.AuditorNameControl.valueChanges.pipe(
    //   debounceTime(300), 
    //   distinctUntilChanged() 
    // ).subscribe(value => {
    //   this.getFilteredValues(value);
    // });
    this.filteredDeliveryManagerNames = this.deliveryManagerNameControl.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value.toLowerCase() : ''),
      map(value => (value.length > 2 ? this.filterManagers(value) : [])) 
    );
    // this.filteredAuditReports = this.auditReportControl.valueChanges.pipe(
    //   startWith(''),  
    //   map(value => this.filterAuditReports(value))  
    // ); 
    this.auditId = 0;
    this.route.params.subscribe(params => {
      this.auditId = parseInt(params['id']);      
    });
    if (this.auditId > 0) {
      this.getAuditInfoByAuditId();
    }
    else{
      this.getprojectName();  
      this.getProjectManagersName();
      this.getDeliveryManagerName();
      this.getPortfolioLeadersName();
    }
    // if(true) {
    //   setTimeout(() => {
    //     this.getArtifactTypes();
    //     this.getArtifactsAccessabiity();
    //     this.GetDevelopmentMethodologyTypes();
    //     this.getAuditFrequencyOptions();
    //   },1000);
    // }   

    this.AuditForm.valueChanges.subscribe(x => {
      // if (x.auditorId != undefined && x.auditorId != null) {
      //   this.auditorChange(x.auditorId);
      // }
       if (x.managerId != undefined && x.managerId != null) {
        this.managerChange(x.managerId);
      }
    });
    // this.auditOverviewService.getProjectDetails(this.auditId).subscribe(
    //   (responseData: any) => {
    //       this.projectDetail = responseData;
    //       this.auditStatus = this.projectDetail.status;     
    //     });
  }

  mapAuditInfo() {
    this.auditModel.statusId = 4;
    this.auditModel.projectId = parseInt(this.AuditForm.get('projectId')?.value);
    this.auditModel.TechStackIds = (this.AuditForm.get('TechStackIds')?.value);
    this.auditModel.managerId = (this.AuditForm.get('managerId')?.value);
    this.auditModel.deliveryManagerId = (this.AuditForm.get('deliveryManagerId')?.value);
    // this.auditModel.auditorId = parseInt(this.AuditForm.get('auditorId')?.value);
    this.auditModel.portfoliomanagerId = parseInt(this.AuditForm.get('portfolioManagerId')?.value);
    this.auditModel.expectedAuditStartDate = this.AuditForm.get('dateControl')?.value;
    const endDateControlValue = this.AuditForm.get('endDateControl')?.value;
    const formattedDate = moment(endDateControlValue, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    this.auditModel.expectedAuditEndDate = formattedDate;
    
  }

 todisable(){
  this.managerNameControl = new FormControl({ value: '', disabled: true });
  this.deliveryManagerNameControl = new FormControl({ value: '', disabled: true }); 
  this.AuditorNameControl = new FormControl({ value: '', disabled: true });
  this.portfolioLeaderControl = new FormControl({ value: '', disabled: true });
    this.projectNameControl.valueChanges.subscribe(value => {
      if (value && value.trim() !== '') {
        this.managerNameControl.enable();
        this.deliveryManagerNameControl.enable();
        this.AuditorNameControl.enable();
        this.portfolioLeaderControl.enable();
      } else {
        this.managerNameControl.disable(); 
        this.deliveryManagerNameControl.disable();
        this.AuditorNameControl.disable();
        this.portfolioLeaderControl.disable();
      }
    });
 }

  mapManagerAuditInfo() {
    // this.auditModel.auditorId = parseInt(this.AuditForm.get('auditorId')?.value);
    this.auditModel.projectId = parseInt(this.AuditForm.get('projectId')?.value);
    this.auditModel.TechStackIds = (this.AuditForm.get('TechStackIds')?.value);
    this.auditModel.managerId = (this.AuditForm.get('managerId')?.value);
    this.auditModel.deliveryManagerId = (this.AuditForm.get('deliveryManagerId')?.value);
    this.auditModel.portfoliomanagerId = (this.AuditForm.get('portfolioManagerId')?.value);
    this.auditModel.generalcategoryDTO = new GeneralCategoryResDTO();
    this.auditModel.generalcategoryDTO.teamSize = parseInt(this.AuditGeneralForm.get('teamSize')?.value);
    this.auditModel.generalcategoryDTO.timeForLastAudit = this.AuditGeneralForm.get('timeForLastAudit')?.value;
    this.auditModel.generalcategoryDTO.auditInitiation = ''; 
    this.auditModel.generalcategoryDTO.scopeOfAudit = this.AuditGeneralForm.get('scopeOfAudit')?.value;
    this.auditModel.generalcategoryDTO.deliveryModel = this.AuditGeneralForm.get('deliveryModel')?.value;
    this.auditModel.generalcategoryDTO.developmentMethodology = parseInt(this.AuditGeneralForm.get('developmentMethodology')?.value);
    this.auditModel.generalcategoryDTO.sourceAndVersionControlStrategy = '';
    this.auditModel.generalcategoryDTO.codeReviewFrequencyAndProcess = this.AuditGeneralForm.get('codeReviewFrequencyAndProcess')?.value;
    this.auditModel.generalcategoryDTO.commitCheckInPolicy = '';
    this.auditModel.generalcategoryDTO.codeStandardsAndGuideLines = '';
    this.auditModel.generalcategoryDTO.recordTeamTypicalDevelopmentAndDeliveryActivities = '';
    // this.auditModel.expectedAuditStartDate = this.auditfo ;

    this.auditModel.generalcategoryDTO.auditFrequency = parseInt(this.AuditGeneralForm.get('auditFrequency')?.value);
    this.auditModel.generalcategoryDTO.projectDocumentationPath = this.AuditGeneralForm.get('projectDocumentationPath')?.value;
    this.auditModel.pointofContactsDTO = [];

    this.pointOfContact = new AuditPointOfContact();
    this.pointOfContact.userId = parseInt(this.AuditPOCForm.get('demoPOCId')?.value);
    this.pointOfContact.pointofContactTypeId = parseInt(this.AuditPOCForm.get('demoPOCTypeId')?.value);
    this.auditModel.pointofContactsDTO.push(this.pointOfContact);

    this.pointOfContact = new AuditPointOfContact();
    this.pointOfContact.userId = parseInt(this.AuditPOCForm.get('architecturePOCId')?.value);
    this.pointOfContact.pointofContactTypeId = parseInt(this.AuditPOCForm.get('architecturePOCTypeId')?.value);
    this.auditModel.pointofContactsDTO.push(this.pointOfContact);

    this.pointOfContact = new AuditPointOfContact();
    this.pointOfContact.userId = parseInt(this.AuditPOCForm.get('designAppPOCId')?.value);
    this.pointOfContact.pointofContactTypeId = parseInt(this.AuditPOCForm.get('designAppPOCTypeId')?.value);
    this.auditModel.pointofContactsDTO.push(this.pointOfContact);

    this.pointOfContact = new AuditPointOfContact();
    this.pointOfContact.userId = parseInt(this.AuditPOCForm.get('overviewPOCId')?.value);
    this.pointOfContact.pointofContactTypeId = parseInt(this.AuditPOCForm.get('overviewPOCTypeId')?.value);
    this.auditModel.pointofContactsDTO.push(this.pointOfContact);

    this.pointOfContact = new AuditPointOfContact();
    this.pointOfContact.userId = parseInt(this.AuditPOCForm.get('nonTechQueryPOCId')?.value);
    this.pointOfContact.pointofContactTypeId = parseInt(this.AuditPOCForm.get('nonTechQueryPOCTypeId')?.value);
    this.auditModel.pointofContactsDTO.push(this.pointOfContact);

    this.pointOfContact = new AuditPointOfContact();
    this.pointOfContact.userId = parseInt(this.AuditPOCForm.get('techQueryPOCId')?.value);
    this.pointOfContact.pointofContactTypeId = parseInt(this.AuditPOCForm.get('techQueryPOCTypeId')?.value);
    this.auditModel.pointofContactsDTO.push(this.pointOfContact);

    this.pointOfContact = new AuditPointOfContact();
    this.pointOfContact.userId = parseInt(this.AuditGeneralForm.get('earlierAuditReportReviewAndApprovedBy')?.value);
    this.pointOfContact.pointofContactTypeId = 8;
    this.auditModel.pointofContactsDTO.push(this.pointOfContact);

    this.auditModel.projectArtifactsDTO = new AuditProjectArtifactModel();
    this.auditModel.projectArtifactsDTO.comments = this.AuditGeneralForm.get('comments')?.value;


    this.auditModel.projectArtifactsDTO.articraftDTO = [];

    this.artifactType = new AuditAccessibilityModel();
    this.artifactType.artifactAccessibilityId = parseInt(this.AuditAccessibilityForm.get('applicationDatabaseId')?.value);
    this.artifactType.artifactTypeId = parseInt(this.AuditAccessibilityForm.get('applicationDatabaseTypeId')?.value);
    this.auditModel.projectArtifactsDTO.articraftDTO.push(this.artifactType);

    this.artifactType = new AuditAccessibilityModel();
    this.artifactType.artifactAccessibilityId = parseInt(this.AuditAccessibilityForm.get('businessRequirementDocumentsId')?.value);
    this.artifactType.artifactTypeId = parseInt(this.AuditAccessibilityForm.get('businessRequirementDocumentsTypeId')?.value);
    this.auditModel.projectArtifactsDTO.articraftDTO.push(this.artifactType);

    this.artifactType = new AuditAccessibilityModel();
    this.artifactType.artifactAccessibilityId = parseInt(this.AuditAccessibilityForm.get('architectureDocumentsId')?.value);
    this.artifactType.artifactTypeId = parseInt(this.AuditAccessibilityForm.get('architectureDocumentsTypeId')?.value);
    this.auditModel.projectArtifactsDTO.articraftDTO.push(this.artifactType);

    this.artifactType = new AuditAccessibilityModel();
    this.artifactType.artifactAccessibilityId = parseInt(this.AuditAccessibilityForm.get('designDocumentsId')?.value);
    this.artifactType.artifactTypeId = parseInt(this.AuditAccessibilityForm.get('designDocumentsTypeId')?.value);
    this.auditModel.projectArtifactsDTO.articraftDTO.push(this.artifactType);

    this.artifactType.artifactAccessibilityId = parseInt(this.AuditAccessibilityForm.get('earlierApplicationAuditDocumentsId')?.value);
    this.artifactType.artifactTypeId = parseInt(this.AuditAccessibilityForm.get('earlierApplicationAuditDocumentsTypeId')?.value);
    this.auditModel.projectArtifactsDTO.articraftDTO.push(this.artifactType);

    this.artifactType = new AuditAccessibilityModel();
    this.artifactType.artifactAccessibilityId = parseInt(this.AuditAccessibilityForm.get('codeAnalysisCodeReviewReportsId')?.value);
    this.artifactType.artifactTypeId = parseInt(this.AuditAccessibilityForm.get('codeAnalysisCodeReviewReportsTypeId')?.value);
    this.auditModel.projectArtifactsDTO.articraftDTO.push(this.artifactType);

    this.artifactType = new AuditAccessibilityModel();
    this.artifactType.artifactAccessibilityId = parseInt(this.AuditAccessibilityForm.get('seperateAppCodeDocumentId')?.value);
    this.artifactType.artifactTypeId = parseInt(this.AuditAccessibilityForm.get('seperateAppCodeDocumentTypeId')?.value);
    this.auditModel.projectArtifactsDTO.articraftDTO.push(this.artifactType);
  }

  selectedSubAuditor: any;

  setAuditInfo(auditInfo: AuditByIdModel) {
    this.selectedSubAuditor = auditInfo.subAuditiorDetails.map(s => s.subAuditiorUserId);
    this.auditModel.CategoryIdsubauditorDTO = [];
    // this.selectedSubAuditor.forEach(v =>{
    //   this.CategoryIdsubauditorModel = new CategoryIdsubauditorDTO;
    //   this.CategoryIdsubauditorModel.SubAuditorID = v;
    //   this.auditModel.CategoryIdsubauditorModel.push(this.CategoryIdsubauditorModel);
    // })
    this.AuditForm.setValue({
      projectId: auditInfo.projectId,
      TechStackIds: auditInfo.technologyStackDTODetails != undefined ? auditInfo.technologyStackDTODetails.map(tsd => tsd.stackId)  : [],
      managerTypeId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 6).length > 0
        ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 6)[0].pointOfContactId : 0,
      // auditorId: auditInfo.auditiorUserId != undefined ? auditInfo.auditiorUserId : 0,
      managerId: auditInfo.managerId != undefined ? auditInfo.managerId : 0,
      deliveryManagerId: auditInfo.deliveryManagerId != undefined ? auditInfo.deliveryManagerId : 0,
      subAuditorIds: auditInfo.subAuditiorDetails.map(s => s.subAuditiorUserId),
      // PortfolioManagerId : auditInfo.port
    });
    this.AuditGeneralForm.setValue({
      generalProjectId: auditInfo.projectId != undefined ? auditInfo.projectId : 0,
      projectDuration: '',
      codeReviewFrequencyAndProcess: auditInfo.codeReviewFrequencyAndProcess,
      teamSize: auditInfo.teamSize,
      timeForLastAudit: auditInfo.timeFromLastAudit,
      earlierAuditReportReviewAndApprovedBy: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 8).length > 0
        ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 8)[0].pocUserId : null,
      scopeOfAudit: auditInfo.scopeOfAudit,
      deliveryModel: auditInfo.deliveryModel,
      developmentMethodology: auditInfo.developmentMethodology,
      comments: auditInfo.comments,     
      auditFrequency: (auditInfo.auditFrequency > 0) ? auditInfo.auditFrequency : 0,
      projectDocumentationPath: auditInfo.projectDocumentationPath
    });
    
    function addOneDay(date = new Date()) {
      date.setDate(date.getDate() + 1);
      return date;
    }

    const date = new Date(auditInfo.expectedAuditStartDate);
    const result2 = addOneDay(date);
    this.auditStartDate = new Date(result2).toISOString().split('T')[0];
    if (auditInfo.pointOfContactsDetails != null && auditInfo.pointOfContactsDetails.length > 0) {
      this.AuditPOCForm.setValue({

        demoPOCId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 1).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 1)[0].pocUserId : 0,
        demoPOCTypeId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 1).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 1)[0].pointOfContactId : 1,

        architecturePOCId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 2).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 2)[0].pocUserId : 0,
        architecturePOCTypeId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 2).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 2)[0].pointOfContactId : 2,

        designAppPOCId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 3).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 3)[0].pocUserId : 0,
        designAppPOCTypeId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 3).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 3)[0].pointOfContactId : 3,

        overviewPOCId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 4).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 4)[0].pocUserId : 0,
        overviewPOCTypeId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 4).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 4)[0].pointOfContactId : 4,

        nonTechQueryPOCId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 5).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 5)[0].pocUserId : 0,
        nonTechQueryPOCTypeId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 5).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 5)[0].pointOfContactId : 5,

        techQueryPOCId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 7).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 7)[0].pocUserId : 0,
        techQueryPOCTypeId: auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 7).length > 0
          ? auditInfo.pointOfContactsDetails.filter(o => o.pointOfContactId == 7)[0].pointOfContactId : 7,
      });
    }
    else {
      this.AuditPOCForm.setValue({
        demoPOCId: 0,
        demoPOCTypeId: 1,

        architecturePOCTypeId: 2,
        architecturePOCId: 0,

        designAppPOCTypeId: 3,
        designAppPOCId: 0,

        overviewPOCTypeId: 4,
        overviewPOCId: 0,

        nonTechQueryPOCTypeId: 5,
        nonTechQueryPOCId: 0,

        techQueryPOCTypeId: 7,
        techQueryPOCId: 0,
      });
    }
    if (auditInfo.artifactDetails != null && auditInfo.artifactDetails.length > 0) {
      this.AuditAccessibilityForm.setValue({
        applicationDatabaseId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 1).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 1)[0].accessId : 0,
        applicationDatabaseTypeId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 1).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 1)[0].artifactTypeId : 1,

        businessRequirementDocumentsId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 2).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 2)[0].accessId : 0,
        businessRequirementDocumentsTypeId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 2).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 2)[0].artifactTypeId : 2,

        architectureDocumentsId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 3).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 3)[0].accessId : 0,
        architectureDocumentsTypeId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 3).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 3)[0].artifactTypeId : 3,

        designDocumentsId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 4).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 4)[0].accessId : 0,
        designDocumentsTypeId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 4).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 4)[0].artifactTypeId : 4,

        applicationCodeRepositoryId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 5).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 5)[0].accessId : 0,
        applicationCodeRepositoryTypeId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 5).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 5)[0].artifactTypeId : 5,

        earlierApplicationAuditDocumentsId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 6).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 6)[0].accessId : 0,
        earlierApplicationAuditDocumentsTypeId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 6).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 6)[0].artifactTypeId : 6,

        codeAnalysisCodeReviewReportsId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 7).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 7)[0].accessId : 0,
        codeAnalysisCodeReviewReportsTypeId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 7).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 7)[0].artifactTypeId : 7,

        seperateAppCodeDocumentId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 8).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 8)[0].accessId : 0,
        seperateAppCodeDocumentTypeId: auditInfo.artifactDetails.filter(o => o.artifactTypeId == 8).length > 0
          ? auditInfo.artifactDetails.filter(o => o.artifactTypeId == 8)[0].artifactTypeId : 8,

      });
    }
  }
  serverError(validationErrors: any) {
    Object.keys(validationErrors).forEach(prop => {
      const formControl = this.AuditForm.get(prop);
      if (formControl) {
        formControl.setErrors({
          serverError: validationErrors[prop].join(','),
        });
      }
    });
  }
  // changeOfSubAuditors(event: any) {
  //   this.auditModel.CategoryIdsubauditorModel = [];
  //   if (event.value != undefined) {
  //     event.value.forEach(element => {
  //       this.CategoryIdsubauditorModel = new CategoryIdsubauditorDTO;
  //       this.subauditorModel.userId = element;
  //       this.auditModel.subAuditorId.push(this.subauditorModel);
  //     });
  //   }
  //   else {
  //     if (event != undefined) {
  //       event.forEach(element => {
  //         this.subauditorModel = new SubAuditorModel;
  //         this.subauditorModel.userId = element;
  //         this.auditModel.subAuditorId.push(this.subauditorModel)
  //       });
  //     }
  //   }
  // }
  auditorChange(data) {
    this.auditorName = this.Auditorname.filter(a => a.userId == data)[0]?.userName;
    this.auditModel.auditorId = this.Auditorname.filter(a => a.userId == data)[0]?.userId;
  }

  managerChange(data) {
    this.managerName = this.storeProjectManagerNames.filter(a => a.userId == data)[0].userName;
    this.auditModel.managerId = this.storeProjectManagerNames.filter(a => a.userId == data)[0].userId;    
  }
  disablePastDates = (d: Date | null): boolean => {
    const today = new Date();
    return d ? d >= today : false;
  }

  updateEndDate(startDateValue: any): void {
    if (startDateValue) {
      let startDate = new Date(startDateValue);
      let endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 15); // Add 15 days

      const formattedEndDate = `${('0' + endDate.getDate()).slice(-2)}/${('0' + (endDate.getMonth() + 1)).slice(-2)}/${endDate.getFullYear()}`;
      this.AuditForm.get('endDateControl').setValue(formattedEndDate);
    }
  }
  subAuditorChange(data) {
    this.Auditcreation.value.subAuditorId.push(data?.subAuditorId);
  }
  filterAuditReports(value: string): any[] {
    const filterValue = value ? value.toLowerCase() : '';
    return this.storePointofContactsNames?.filter(report =>
      report.userName.toLowerCase().includes(filterValue)
    );
  }
  onDeliveryManagerSelected(value) {
    const selectedDeliveryManagerId = value;
    const selectedDeliveryManagerName = this.filteredDeliveryManagerNames.find(manager => manager.managerId === selectedDeliveryManagerId)?.managerName;
    this.deliveryManagerNameControl.setValue(selectedDeliveryManagerName);
    this.AuditForm.get('deliveryManagerId').setValue(selectedDeliveryManagerId);
  }
  approvedBy(data) {
    this.auditModel.generalcategoryDTO.earlierAuditReportReviewAndApprovedBy = data;
  }

  AuditCreateDetails() {
    this.auditModel.createdBy = this.loginId;
    this.auditModel.createdDate = this.currentDateTime;
    if (this.auditId == undefined || this.auditId == 0 || Number.isNaN(this.auditId)) {
      if (this.AuditForm.valid) {
        this.mapAuditInfo();
        this.auditModel.auditId = 0;
        this.auditdetailsservice.saveAuditcreation(this.auditModel).subscribe(
          (response) => {
            this.id = response
            this.auditSharedService.setAuditId(this.id);
            this.auditOverviewService.setAuditorEmployeeId(this.auditModel.auditorId);
            localStorage.setItem('AuditorId',this.auditModel.auditorId?.toString());
            this.router.navigate(['Home/Audit']);
            this.toaster.success("Audit Created successfully");
          //   if(this.auditModel.auditId == 0){
          //   this.router.navigate(['Home/Audit/Auditor Detail/Audit Overview']);
          // }
          },
          (error) => {
            if (error?.error?.errors != null) {
              const validationErrors = error.error.errors;
              this.serverError(validationErrors);
            } 
            this.auditSharedService.setAuditId(this.id);
            this.toaster.error("Error in saving the audit details. Please try again.");
            // this.router.navigate(['Home/Audit']);
          });
      }
    }
    else {
      if (this.AuditGeneralForm.valid && this.AuditPOCForm.valid ) {
        this.mapManagerAuditInfo();
        if (this.auditStatus !== "Audit Initiated" || this.auditModel.statusId !== undefined) {
          this.auditModel.statusId = 4;
      }
      else{
        this.auditModel.statusId = 1;
      }
        this.auditModel.auditId = this.auditId;
        this.auditModel.modifiedBy = this.loginId;
        this.auditModel.modifiedDate = this.currentDateTime;       
        this.auditdetailsservice.saveManagerAuditdetails(this.auditModel).subscribe(
          (response) => {
            this.id = response;
            this.toaster.success("Audit details Saved/Updated Successfully.");
            this.auditSharedService.setAuditId(this.id);
            setTimeout(()=>{ this.router.navigate(['Home/Audit']); },500);            
          },
          (error) => {
            if (error?.error?.errors != null) {
              const validationErrors = error.error.errors;
              this.serverError(validationErrors);
            }
            this.toaster.error("Audit details not Saved/Updated Successfully.");
          });
      }
      else {
           let validationMessage:string = (this.AuditGeneralForm.valid && !this.AuditPOCForm.valid)
                              ? 'Fill the mandatory project point of contacts.'
                              : 'Fill the mandatory details to save/update audit info.';        
        return this.toaster.warning(validationMessage);
      }
    }
  }

  getAuditInfoByAuditId() {
    this.auditdetailsservice.getAuditInfoByAuditId(this.auditId).subscribe(
      (response: AuditByIdModel) => {
        this.auditByIdModel = response;
        this.AuditForm.get('projectId').setValue(this.auditByIdModel.projectId);
        if(this.projectnames?.length > 0){
          this.storeProjectName = this.projectnames?.filter(p => p.projectId == this.auditByIdModel.projectId)[0]?.projectName;
        }
        this.auditorName = this.auditByIdModel?.auditiorName;
        if(this.auditByIdModel?.pointOfContactsDetails?.filter(x => x.pointOfContactId == 6)?.length > 0){
          this.managerName = this.auditByIdModel?.pointOfContactsDetails?.filter(x => x.pointOfContactId == 6)[0].pocUserName;
          const project_manager_id:number = this.auditByIdModel?.pointOfContactsDetails?.filter(x => x.pointOfContactId == 6)[0].pocUserId;
          this.getprojectNameByManagerId(project_manager_id,this.auditByIdModel.projectId);
        }

        const forkManager = this.http.get(this.ApiUrl + 'AuditDetails/GetManagerNamebyProjectId?ProjectId=' + this.auditByIdModel.projectId);
        const forkTech = this.http.get(this.ApiUrl + 'AuditDetails/GetTeckStackbyProjectId?projectId=' + (parseInt(this.AuditForm.get('projectId')?.value)));
        const forkPOC = this.http.get(this.ApiUrl + 'AuditDetails/GetPointofContactName?ProjectId=' + (parseInt(this.AuditForm.get('projectId')?.value)));

        const forkArtifact = this.http.get<ArtifactAccessibilityModel[]>(this.ApiUrl + 'AuditArtifacts/GetArtifactsAccessabiity');
        const forkArtifactType = this.http.get(this.ApiUrl + 'AuditArtifacts/GetArtifactType');
        const forkMethodology = this.http.get<DevelopmentMethodologyModel[]>(this.ApiUrl + 'AuditCreation/GetDevelopmentMethodologyTypes');
        
        forkJoin([forkTech, forkPOC, forkArtifact, forkArtifactType, forkMethodology,forkManager])
          .subscribe((res: any) => {
            this.storeTechnology = res[0]?.filter(x => x.id == this.auditByIdModel.technologyStackDTODetails?.some(y => y.stackId == x.id));
            this.storePointofContactsNames = res[1];
            this.artifactAccessibilities = res[2];
            if (!this.hasRoleName || (this.hasRoleName && this.auditId > 0)) {
              this.AuditAccessibilityForm.setValue({
                applicationDatabaseTypeId: res[3].filter(a => a.id == 1)[0].id,
                businessRequirementDocumentsTypeId: res[3].filter(a => a.id == 2)[0].id,
                architectureDocumentsTypeId: res[3].filter(a => a.id == 3)[0].id,
                designDocumentsTypeId: res[3].filter(a => a.id == 4)[0].id,
                applicationCodeRepositoryTypeId: res[3].filter(a => a.id == 5)[0].id,
                earlierApplicationAuditDocumentsTypeId: res[3].filter(a => a.id == 6)[0].id,
                codeAnalysisCodeReviewReportsTypeId: res[3].filter(a => a.id == 7)[0].id,
                seperateAppCodeDocumentTypeId: res[3].filter(a => a.id == 8)[0].id,

                applicationDatabaseId: null,
                businessRequirementDocumentsId: null,
                architectureDocumentsId: null,
                designDocumentsId: null,
                applicationCodeRepositoryId: null,
                earlierApplicationAuditDocumentsId: null,
                codeAnalysisCodeReviewReportsId: null,
                seperateAppCodeDocumentId: null,
              });

              this.developmentMethodologies = res[4];
              this.storeProjectManagerNames = res[5];
            }

            
            this.setAuditInfo(response);

          });

      },
      (error) => {
      });
  }

  getcategorydetails() {
    this.auditdetailsservice.getcategorydetails().subscribe(
        (response) => {
        },
        (error) => {
        }
    );
}


  getprojectName() {
    this.auditdetailsservice.getProjectName().subscribe(
      (response: projectNamesModel[]) => {
        this.projectnames = response;   
        this.makeSingleListOptionSelected('PROJECT');     
      });
  }

  getprojectNameByManagerId(managerId:number, projectId:number = 0) {
    this.auditdetailsservice.getProjectNameByManagerId(managerId).subscribe(
      (response: projectNamesModel[]) => {
        this.projectnames = response;
        if(projectId > 0)
        {
          this.storeProjectName = this.projectnames?.filter(p => p.projectId == projectId)[0]?.projectName;
          this.projectnames = this.projectnames?.filter(p => p.projectId == projectId);
        }
        this.makeSingleListOptionSelected('PROJECT');
      },
      (error) => {
      }
      );
  }

  getAuditorName() {
    this.auditdetailsservice.getAuditorName()
      .subscribe((response: any) => {
        this.Auditorname = response
        this.filteredSubAuditorsName = this.Auditorname;
      });
  }

  getSubAuditorName() {
    this.auditdetailsservice.getSubAuditorName()
      .subscribe((response: any) => {
        this.subauditor = response
      });
  }

  getArtifactsAccessabiity() {
    this.auditdetailsservice.getArtifactsAccessabiity()
      .subscribe((response: ArtifactAccessibilityModel[]) => {
        this.artifactAccessibilities = response
      });
  }

  GetDevelopmentMethodologyTypes() {
    this.auditdetailsservice.GetDevelopmentMethodologyTypes()
      .subscribe((response: DevelopmentMethodologyModel[]) => {
        this.developmentMethodologies = response
      });
  }

  getTechStack() {
    this.auditdetailsservice.getTechStack(this.Auditcreation.value.projectId).subscribe((response: any) => {
      this.techstack = response;
    });
  }

  getArtifactTypes() {
    this.auditdetailsservice.getArtifactTypes().subscribe((response: any) => {
      this.AuditAccessibilityForm.setValue({
        applicationDatabaseTypeId: response.filter(a => a.id == 1)[0].id,
        businessRequirementDocumentsTypeId: response.filter(a => a.id == 2)[0].id,
        architectureDocumentsTypeId: response.filter(a => a.id == 3)[0].id,
        designDocumentsTypeId: response.filter(a => a.id == 4)[0].id,
        applicationCodeRepositoryTypeId: response.filter(a => a.id == 5)[0].id,
        earlierApplicationAuditDocumentsTypeId: response.filter(a => a.id == 6)[0].id,
        codeAnalysisCodeReviewReportsTypeId: response.filter(a => a.id == 7)[0].id,
        seperateAppCodeDocumentTypeId: response.filter(a => a.id == 8)[0].id,
        applicationDatabaseId: null,
        businessRequirementDocumentsId: null,
        architectureDocumentsId: null,
        designDocumentsId: null,
        applicationCodeRepositoryId: null,
        earlierApplicationAuditDocumentsId: null,
        codeAnalysisCodeReviewReportsId: null,
        seperateAppCodeDocumentId: null,
      });
    })
  }

  getPointOfContactTypes() {
    this.auditdetailsservice.getPointOfContactTypes().subscribe((response: any) => {
      this.AuditPOCForm.setValue({
        demoPOCTypeId: response.filter(a => a.name == 'Application')[0].id,
        demoPOCId: null,
        architecturePOCTypeId: response.filter(a => a.name == 'Architecture')[0].id,
        architecturePOCId: null,
        designAppPOCTypeId: response.filter(a => a.name == 'Design')[0].id,
        designAppPOCId: null,
        overviewPOCTypeId: response.filter(a => a.name == 'FunctionalOverview')[0].id,
        overviewPOCId: null,
        nonTechQueryPOCTypeId: response.filter(a => a.name == 'Non-TechnicalQueries')[0].id,
        nonTechQueryPOCId: null,
        techQueryPOCTypeId: response.filter(a => a.name == 'TechnicalQueries')[0].id,
        techQueryPOCId: null
      });
      this.AuditSummaryForm.setValue({
        projectPOCId: [null, Validators.required],
        projectPOCTypeId: response.filter(a => a.name == 'ProjectPointOfContact')[0].id,        
      });
      this.AuditForm.setValue({         
        projectId:null,
        techStackID:null,
        auditorId:null,
        managerId:null,
        deliveryManagerId: null,
        managerTypeId:response.filter(a => a.name == 'ProjectManager')[0].id,
        subAuditorIds:null      
      });
    });
  }


  loadTechnology(projectName: string) {
    const selectedProject = this.projectnames.find(p => p.projectName === projectName);
    if (selectedProject) {
      this.storeProjectName = selectedProject.projectName;
      this.projectNameControl.setValue(selectedProject.projectName);
      this.AuditForm.get('projectId')?.setValue(selectedProject.projectId);
      const projectIdValue = parseInt(this.AuditForm.get('projectId')?.value, 10);
  
      if (projectIdValue > 0) {
        this.resetProjectDependentFields();
        this.getTechStackNames(projectIdValue);
      }
  
      if (!this.hasRoleName || this.auditId > 0) {
        this.getArtifactsAccessabiity();
        this.GetDevelopmentMethodologyTypes();
      }
    }
  }
  onProjectSelected(projectName: string) {
    // this.getProjectManagersName();
    // this.getPortfolioLeadersName();
    const selectedProject = this.projectnames.find(p => p.projectName === projectName);
    if (selectedProject) {
        const projectId = selectedProject.projectId;
        this.auditdetailsservice.getProjectDetailsById(projectId).subscribe(projectDetails => {
            if (projectDetails && projectDetails.length > 0) {
                const project = projectDetails[0];
                this.AuditForm.patchValue({
                    managerId: project.projectManagerId,
                    deliveryManagerId: project.deliveryManagerId,
                    portfolioManagerId: project.portfolioManagerId
                });
                console.log(this.AuditForm);
                this.managerNameControl.setValue(project.projectManager);
                this.deliveryManagerNameControl.setValue(project.deliveryManager);
                this.portfolioLeaderControl.setValue(project.portfolioManagerName);
            } else {
                this.AuditForm.patchValue({
                    managerId: null,
                    deliveryManagerId: null,
                    portfoliomanagerId: null,
                    TechStackIds : null
                });
                this.managerNameControl.setValue(null);
                this.deliveryManagerNameControl.setValue(null);
                this.portfolioLeaderControl.setValue(null); 
                this.TechStackIds.fill(null);
            }    
            this.storeProjectName = selectedProject.projectName;
            this.projectNameControl.setValue(selectedProject.projectName);
            this.AuditForm.get('projectId')?.setValue(selectedProject.projectId);

            const projectIdValue = parseInt(this.AuditForm.get('projectId')?.value, 10);
            if (projectIdValue > 0) {
                this.resetProjectDependentFields();
                this.getTechStackNames(projectIdValue);
            }

            if (!this.hasRoleName || this.auditId > 0) {
                this.getArtifactsAccessabiity();
                this.GetDevelopmentMethodologyTypes();
            }
        });
    } 
    else {
        // If project name is cleared, reset all fields
        this.AuditForm.patchValue({
            projectId: null,
            managerId: null,
            deliveryManagerId: null,
            auditorId: null,
            portfoliomanagerId: null
        });

        this.projectNameControl.setValue(null);
        this.managerNameControl.setValue(null);
        this.deliveryManagerNameControl.setValue(null);
        this.AuditorNameControl.setValue(null);
        this.portfolioLeaderControl.setValue(null);
    }
  }
  onLeaderSelected(value) {
    const selectedLeaderId = parseInt(value);
    const selectedLeaderName = this.filteredPortfolioLeaderNames.find(leader => leader.portfolioManagerId === selectedLeaderId)?.portfolioManagerName;
    this.portfolioLeaderControl.setValue(selectedLeaderName);
    this.AuditForm.get('portfoliomanagerId').setValue(selectedLeaderId);
  }
  // loadAuditors(auditorName: string) {
  //   const selectedAuditor = this.Auditorname.find(a => a.userName === auditorName);
  //   if (selectedAuditor) {
  //     this.AuditForm.get('auditorId')?.setValue(selectedAuditor.userId);
  //   }
  // }
  showAllAuditors() {
    this.filteredAuditors = this.Auditorname;
  }
  showAllProjects() {
    this.filteredProjects = this.projectnames;
  }
  
  displayManagerName(manager: any): string {
    return manager ? manager.userName : '';
  }
  filterManagers(value: string): any[] {
    if(value == ''){
      this.filteredProjectManagerNames = this.storeProjectManagerNames
    }
    else{
      const filterValue = value.toLowerCase();
      this.filteredProjectManagerNames =  this.storeProjectManagerNames.filter(manager => manager.managerName.toLowerCase().includes(filterValue));
    }
    return this.filteredProjectManagerNames;
  }

  filterDeliveryManagers(value: string): any[] {
    if(value == ''){
      this.filteredDeliveryManagerNames = this.storeDelieveryManagerNames
    }
    else{
      const filterValue = value.toLowerCase();
      this.filteredDeliveryManagerNames =  this.storeDelieveryManagerNames.filter(manager => manager.managerName.toLowerCase().includes(filterValue));
    }
    return this.filteredDeliveryManagerNames;
  }
  filterLeaders(value: string): any[] {
    if(value == ''){
      this.filteredPortfolioLeaderNames = this.storePortfolioLeaderNames;
    }
    else{
      const filterValue = value.toLowerCase();
      this.filteredPortfolioLeaderNames = this.storePortfolioLeaderNames.filter(leader =>
        leader.portfolioManagerName.toLowerCase().includes(filterValue)
      );    }
   return this.filteredPortfolioLeaderNames;
  }
  filterProjects(value: string) {
    const filterValues = value.toLowerCase();
    this.filteredProjects = this.projectnames.filter(project => project.projectName.toLowerCase().includes(filterValues));
  }
  getFilteredValues(event: string) {
    const specialCharsRegex = /[!#$%^&*_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if ( event && specialCharsRegex.test(event) || event.length < 3) {
      this.filteredAuditors = [];
      return;
    } else {
      const inputValue = event.toLowerCase();
      this.filteredAuditors = this.Auditorname.filter(auditor =>
        auditor.userName.toLowerCase().includes(inputValue)
      );
    }
  }
  getPortfolioLeadersName() {
    this.auditdetailsservice.getAllLeadersName().subscribe(
      (response: any) => { 
        this.filteredPortfolioLeaderNames = response;
        this.storePortfolioLeaderNames = response;
      });
  }
  getLeaderNamesByProjectId(projectId: number) {
    this.auditdetailsservice.getPortfolioLeaderByProjectId(projectId).subscribe(
      (response: any) => { 
        this.storePortfolioLeaderNames = response; 
        if(response?.length == 1){
          this.AuditForm.patchValue({
            leaderId: response[0].userId
          });
        }
      });
  }
  // loadAuditors(auditorName: string) {
  //   const selectedAuditor = this.filteredAuditors.find(auditor => auditor.userName === auditorName);
  //   if (selectedAuditor) {
  //     this.AuditForm.get('auditorId')?.setValue(selectedAuditor.userId); 
  //   }
  // }
  onManagerSelected(value) {
    const selectedManagerId = parseInt(value);
    const selectedManagerName = this.filteredProjectManagerNames.find(manager => manager.managerId === selectedManagerId)?.managerName;
    this.managerNameControl.setValue(selectedManagerName);
    this.AuditForm.get('managerId').setValue(selectedManagerId);
  }
  // onDeliveryManagerSelected(value){
  //   const selectedDeliveryManagerId = parseInt(value);
  //   const selectedDeliveryManagerName = this.storeProjectManagerNames.find(manager => manager.userId === selectedDeliveryManagerId)?.userName;
  //   this.managerNameControl.setValue(selectedDeliveryManagerName);
  //   this.AuditForm.get('deliverymanagerId').setValue(selectedDeliveryManagerId);
  // }

  getTechStackNames(projectId: number) {
    this.auditdetailsservice.getTechStack(projectId).subscribe((response: any) => {
      this.storeTechnology = response;
      this.makeSingleListOptionSelected('TECH');
    })
  }


  getManagerNames(value: number) {
    this.auditdetailsservice.getManagerName(value)
      .subscribe((response: any) => { this.storeManagerNames = response });
  }
  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    const selectedUserId = event.option.value; 
    this.projectPOCControl.setValue(selectedUserId); 
  }
  displayWith(topic: any): string {
    return topic ? topic.userName : '';
  }
  filter(value: string): any[] {
    const filterValue = (value || '').toLowerCase();
    return this.storePointofContactsNames?.filter(option => 
      option.userName.toLowerCase().includes(filterValue)
    );
  }

  getManagerNamesByProjectId(projectId: number) {
    this.auditdetailsservice.getProjectManagerNamesByProjectId(projectId).subscribe(
      (response: any) => { 
        this.storeProjectManagerNames = response; 
        if(response?.length == 1){
          this.AuditForm.patchValue({
            managerId: response[0].userId
          });
        }
      });
  }

  getProjectPointofContactNames(value: number) {
    this.auditdetailsservice.getProjectPointofContactName(value)
      .subscribe((response: any) => { this.storeProjectPointofContact = response })
  }
  getMiddleTierorCloudPointofContactNames(value: number) {
    this.auditdetailsservice.getMiddleTierorCloudPointofContactName(value)
      .subscribe((response: any) => { this.storeCloudOrMiddleTierPointofContact = response })
  }
  getFunctionalOverviewPointOfContacts(value: number) {
    this.auditdetailsservice.getPointofContactName(value)
      .subscribe((response: any) => { this.storeFunctionalOverviewPointOfContacts = response })
  }
  getOverAllApplicationPointOfContacts(value: number) {
    this.auditdetailsservice.getPointofContactName(value)
      .subscribe((response: any) => { this.storeOverAllApplicationPointOfContacts = response })
  }
  getOverAllArchitecturePointOfContacts(value: number) {
    this.auditdetailsservice.getPointofContactName(value)
      .subscribe((response: any) => { this.storeOverAllArchitecturePointOfContacts = response })
  }
  getOverAllDesignPointOfContacts(value: number) {
    this.auditdetailsservice.getPointofContactName(value)
      .subscribe((response: any) => { this.storeOverAllDesignPointOfContacts = response })
  }
  getTechnicalPointOfContacts(value: number) {
    this.auditdetailsservice.getPointofContactName(value)
      .subscribe((response: any) => { this.storeTechnicalPointOfContacts = response })
  }
  getNonTechnicalPointOfContacts(value: number) {
    this.auditdetailsservice.getPointofContactName(value)
      .subscribe((response: any) => { this.storeNonTechnicalPointOfContacts = response })
  }

  getProjectManagersName() {
    this.auditdetailsservice.getAllManagersName().subscribe(
      (response: any) => { 
        this.storeProjectManagerNames = response ;       
        this.filteredProjectManagerNames = response;
      });
  }

  getDeliveryManagerName(){
    this.auditdetailsservice.getAllDeliveryManagerNames().subscribe(
      (response: any) => { 
        this.storeDelieveryManagerNames = response ;
        this.filteredDeliveryManagerNames = response;
      });
  }

  getAuditFrequencyOptions(){
    this.auditdetailsservice.getAuditFrequencyOptions().subscribe(
      (response: Array<AuditFrequencyModel>) => {
        this.auditFreqOptions = response;
      },
      (error) => {
      }
    );
  }

  showBlock() {
    this.isBlockVisible = !this.isBlockVisible;
  }

  showBlock1() {
    this.isBlockVisible1 = !this.isBlockVisible1;
  }

  showBlock2() {
    this.isBlockVisible2 = !this.isBlockVisible2;
  }

  showBlock3() {
    this.isBlockVisible3 = !this.isBlockVisible3;
  }

  showBlock4() {
    this.isBlockVisible4 = !this.isBlockVisible4;
  }

  navigateToProjectDisplay(){
    this.router.navigate(['/Home/Audit']);
  }
  navigateToProjectOverview(){
    this.auditSharedService.setAuditId(this.auditId);
    this.router.navigate(['Home/Audit/Audit Overview']);
  }

  onSubAuditorInputChange(event: any) {
    const searchInput = event.target.value.toLowerCase();
    this.filteredSubAuditorsName = this.Auditorname.filter(subAuditor => {
      const name = subAuditor.userName.toLowerCase();
      const id = subAuditor.userId.toString().toLowerCase(); 
      return name.includes(searchInput) || id.includes(searchInput);
    });
  }

  onSubAuditorOpenChange(searchInput: any) {
    searchInput.value = "";
    this.filteredSubAuditorsName = this.Auditorname;
  }

  // displaySelectedSubAuditorsName()
  // {
  //   const selectedUserIDs= this.AuditForm.get('subAuditorIds')?.value
  //   if(Array.isArray(selectedUserIDs))
  //   {
  //     const results:Array<UserModel> = this.filteredSubAuditorsName.filter(({ userId }) => selectedUserIDs.includes(userId));
  //     let user_names = results.map(user => user.userName).join(',');
  //     if(results?.length > 1)
  //     {
  //       let name = results[0].userName;
  //       name = (name?.length > 15) ? name.substring(0,11) + '...' : name;
  //       user_names = `${name} +${(results?.length - 1)}`;
  //     }
  //     return user_names;
  //   }

  //   return "";
  // }

  resetProjectDependentFields(){    
    try{
      this.AuditForm.patchValue({
        techStackID: null,
        auditorId: null,
        subAuditorIds: null,        
      });

      this.auditorName = null;
    }
    catch(error){
    }
  }

  resetManagerDependentFields(){    
    try{
      this.AuditForm.patchValue({
        projectId: null,
        techStackID: null,
        auditorId: null,
        subAuditorIds: null
      });

      this.storeProjectName = null;
      this.auditorName = null;
    }
    catch(error){
    }
  }
  onprojectmanagerchange(event : any){
    this.filterManagers(event);
  }
  onportfoliomanagerchange(event: any){
    this.filterLeaders(event);
  }

  ondeliverymanagerchange(event: any){
    this.filterDeliveryManagers(event);
  }
  makeSingleListOptionSelected(type:string)
  {
    type = type?.toLocaleUpperCase();
    switch (type) {
      case 'PROJECT':
        if(this.projectnames && this.projectnames?.length == 1){
          const _projectId:number = this.projectnames[0].projectId;
          this.AuditForm.patchValue({projectId: _projectId});
          this.storeProjectName = this.projectnames.filter(p => p.projectId == _projectId)[0].projectName;
          this.getTechStackNames(_projectId);
        }        
        break;
        case 'TECH':          
          if(this.storeTechnology && this.storeTechnology?.length > 0){
            const techStackIDs = this.storeTechnology.map(tech => tech.id);
            this.AuditForm.patchValue({ techStackID: techStackIDs });
          }
          break;
    }
  }

}